<icc-list
    [items]="layouts"
    itemImgHeight="medium"
    (select)="selectedMuntinLayout($event)"
    [searchable]="true"
    [itemTemplate]="'itemImgTitle'"
></icc-list>
